import React, {FC, useEffect, useMemo, useRef} from "react";
import style from "@src/pages/History/HistoryDetails/HistoryDetails.module.scss"
import * as Yup from "yup";
import {Form, Formik} from "formik";
import {getVehicleTypeFromVehicleSlug} from "@src/customFunctions/General";


import {useDispatch, useSelector} from "react-redux";
import {selectOrdersPassengersQuantity} from "@src/store/ducks/orders/selectors";
import {AppDispatch} from "@src/store/store";
import {selectAvailablePlaces, selectUserInfo} from "@src/store/ducks/user/selectors";
import moment from "moment/moment";
import {
    getBusPlacesAsinc, getHistoryAsinc,
    getHistoryNewArrCityAsync,
    updatePreOrderAsync
} from "@src/store/ducks/orders/thunks";


import {validateForm} from "@src/messages/validateForm";
import {setBackError} from "@src/store/ducks/auth/reducer";
import {HistoryPreOrderStep2} from "@src/pages/History/HistoryPreOrder/HistoryPreOrderStep2";
import {HistoryPreOrderStep3} from "@src/pages/History/HistoryPreOrder/HistoryPreOrderStep3";
import {Calendar} from "@src/components/AllSvg/Calendar";
import {HistoryPreOrderStep4} from "@src/pages/History/HistoryPreOrder/HistoryPreOrderStep4";
import {HistoryPreOrderStep6} from "@src/pages/History/HistoryPreOrder/HistoryPreOrderStep6";
import {Button} from "@src/components/Button/Button";
import {Success} from "@src/components/AllSvg/Success";


type TableHistoryElemProps = {
    data: any,
    setShowPreorder: any
};

export const HistoryPreOrder: FC<TableHistoryElemProps> = ({data, setShowPreorder}) => {
    const dispatch = useDispatch<AppDispatch>()
    const passengersQuantity = useSelector(selectOrdersPassengersQuantity)
    const chosenUser = useSelector(selectUserInfo)
    const availablePlaces = useSelector(selectAvailablePlaces)
    const orderNumber = OrderNumber()
    const currentDate = moment().format('DD.MM.YYYY');
    const user = useSelector(selectUserInfo)
    const currentPlaces =
        data?.places
            ?.map((item: any) => item.place)
            .filter((place: any) => place !== '') ?? [];

    useEffect(() => {
        dispatch(getHistoryNewArrCityAsync(String(data.id)))
    }, [data.id]);

    useEffect(() => {
        dispatch(getBusPlacesAsinc(data.trip.id, data.id, true))
    }, [data.id, data.trip.id, dispatch]);

    const vehicleType = getVehicleTypeFromVehicleSlug(data.trip.bus.slug)

    function setTimeDateFmt(s: any) {// однозначные цифры составляют десять цифр
        return s < 10 ? '0' + s : s;
    }

    function OrderNumber() {
        const now = new Date()
        let month = now.getMonth() + 1
        let day = now.getDate()
        let hour = now.getHours()
        let minutes = now.getMinutes()
        let seconds = now.getSeconds()
        month = setTimeDateFmt(month)
        day = setTimeDateFmt(day)
        hour = setTimeDateFmt(hour)
        minutes = setTimeDateFmt(minutes)
        let orderCode = (day + month.toString() + hour + seconds).toString();
        return orderCode;
    }


    const validationSchema1 = useMemo(() => (
        Yup.object().shape({
            sourceRegistration: Yup.mixed().required(validateForm.required),
            data: Yup.object().shape({
                tourists: Yup.array().of(Yup.object().shape({
                    fio: Yup.string().required(validateForm.required),
                    birthDate: Yup.string().matches(/^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.\d{4}$/, 'Неверный формат даты').required(validateForm.required),
                    passportIssueDate: Yup.string().matches(/^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.\d{4}$/, 'Неверный формат даты').required(validateForm.required),
                    passportExpiryDate: Yup.string().matches(/^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.\d{4}$/, 'Неверный формат даты').required(validateForm.required),
                    passportSeriesAndNumber: Yup.string().required(validateForm.required),
                    phoneNumber: Yup.string().matches(/^\+\d{3}\s\(\d{2}\)\s\d{7}$/, 'Неверный формат номера телефона').required(validateForm.required),
                }))
            }),
            selectsArr: Yup.array().of(Yup.object().shape({
                roomType: Yup.mixed().required(validateForm.required),
                gender: Yup.mixed().required(validateForm.required),
                /*                citizenCategory: Yup.mixed().required(validateForm.required),*/
                fromCity: Yup.mixed().required(validateForm.required),
            })),
        })
    ), [])
    const validationSchema2 = useMemo(() => (
        Yup.object().shape({
            sourceRegistration: Yup.mixed().required(validateForm.required),
            data: Yup.object().shape({
                tourists: Yup.array().of(Yup.object().shape({
                    fio: Yup.string().required(validateForm.required),
                    birthDate: Yup.string().matches(/^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.\d{4}$/, 'Неверный формат даты').required(validateForm.required),
                }))
            }),
        })
    ), [])

    const validationSchema3 = useMemo(() =>
            Yup.object({
                data: Yup.object({
                    tourists: Yup.array().of(
                        Yup.object({
                            fio: Yup.string().test(
                                'required-only-first',
                                validateForm.required,
                                function (value) {
                                    const index = Number(this.path.match(/\d+/)?.[0])
                                    if (index === 0) {
                                        return Boolean(value)
                                    }
                                    return true
                                }
                            ),
                            phoneNumber: Yup.string().test(
                                'phone-only-first',
                                'Неверный формат номера телефона',
                                function (value) {
                                    const index = Number(this.path.match(/\d+/)?.[0])

                                    if (index !== 0) return true

                                    if (!value) return false

                                    return /^\+\d{3}\s\(\d{2}\)\s\d{7}$/.test(value)
                                }
                            ),
                        })
                    ),
                }),
            }),
        [])

    const initialValues = useMemo(() => ({
        selectsArr: [...Array(data.tourists.length ? +data.tourists.length : 0)].map(() => ({})),
        passengersQuantity: '',
        sourceRegistration: user.roleId === 2 ? 'Агент' : '',
        fromCity: '',
        roomType: '',
        gender: '',
        citizenCategory: '',
        data: {
            passengersQuantity: data.tourists.length,
            activeHotel: data.hotelId,
            isPreorder: 0,
            number: orderNumber,
            status: '2',
            startDate: data.startDate,
            endDate: data.endDate,
            source: "#description_link_to_other_pageApi",
            userId: chosenUser.id,
            tourId: data.tour.id,
            tripId: data.trip.id,
            busId: data.busId,
            availablePlaces: availablePlaces,
            holdPlaces: +passengersQuantity.value,
            applicationDate: currentDate,
            sourceRegistration: user.roleId === 2 ? 'AGENT' : data.sourceRegistration ? data.sourceRegistration : '',
            additionalExcursions: '',
            finalPriceByn: data.finalPriceByn ? data.finalPriceByn : 0,
            finalFirstPartPriceByn: data.finalFirstPartPriceByn ? data.finalFirstPartPriceByn : 0,
            finalSecondPartPriceByn: data.finalSecondPartPriceByn ? data.finalSecondPartPriceByn : 0,
            priceUsdPart1: data.trip.priceUsdPart_1,
            priceUsdPart2: data.trip.priceUsdPart_2,
            priceUsdPart3: data.trip.priceUsdPart_3,
            priceUsdType5Part1: data.priceUsdType_5Part_1,
            priceUsdType5Part2: data.priceUsdType_5Part_2,
            finalPriceFieldUsdFirstPartPrice: data.finalPriceFieldUsdFirstPartPrice,
            finalPriceFieldUsdSecondPartPrice: data.finalPriceFieldUsdSecondPartPrice,
            finalPriceUsd: data.finalPriceUsd ? data.finalPriceUsd : 0,
            createdAt: currentDate,
            updatedAt: currentDate,
            useFreePlaces: data.useFreePlaces,
            selectedPlaces: currentPlaces,
            tourists: (data.tourists ?? []).map((tourist: any) => ({
                state: '0',
                fio: tourist.fio ?? '',
                fioLat: tourist.fioLat ?? '',
                birthDate: tourist.birthDate ?? '',
                passportIssueDate: tourist.passportIssueDate ?? '',
                passportExpiryDate: tourist.passportExpiryDate ?? '',
                passportSeriesAndNumber: tourist.passportSeriesAndNumber ?? '',
                phoneNumber: tourist.phoneNumber ?? '',
                roomType: '',
                hotel: '',
                gender: tourist.gender ?? '',
                fromCity: '',
                citizenCategory: tourist.citizenCategory ?? '',
                nationality: tourist.nationality ?? '',
            }))
        }
    }), [])

    const step2ValidatorRef = useRef<null | (() => Promise<boolean>)>(null);

    return (
        <div className={style.HistoryPreOrder}>
            <Formik
                initialValues={initialValues}
                validationSchema={Yup.lazy((values: any) => {
                    if (!values) {
                        return validationSchema2
                    }

                    if (values.data.isPreorder) {
                        return validationSchema3
                    }

                    return chosenUser.roleId === 2
                        ? validationSchema1
                        : validationSchema2
                })}
                enableReinitialize={true}
                onSubmit={async (values, helpers) => {
                    dispatch(setBackError(null));
                    dispatch(updatePreOrderAsync(String(data.id),values.data));
                    setShowPreorder(false)
                }}
            >
                {({values, errors}) => {
                    return (
                        <>
                            <Form>
                                <div className={style['history-details']}>
                                    <div className={style['final-order']}>
                                        <div className={style.title}>
                                            Итоговые данные заявки
                                        </div>
                                        <div className={style['final-order-titleBlock']}>
                                            <div className={style['tour-date']}>
                                                <Calendar/>
                                                <span>{values.data.startDate}</span> - <span>{values.data.endDate}</span>
                                            </div>
                                            <div className={style['tour-title']}>
                                                {data.tour.title}
                                            </div>
                                        </div>
                                        <HistoryPreOrderStep2
                                            vehicleType={vehicleType}
                                            quantity={values.data.passengersQuantity}
                                            registerValidator={(fn) => {
                                                step2ValidatorRef.current = fn;
                                            }}
                                            data={data}
                                        />
                                        {vehicleType === 'bus' &&
                                            <HistoryPreOrderStep3 order={data} name='data.selectedPlaces'/>
                                        }
                                        {data.paymentType !== 1 && <HistoryPreOrderStep6 vehicleType={vehicleType} data={data}/>}
                                        <HistoryPreOrderStep4 vehicleType={vehicleType} data={data}/>
                                        <Button
                                            svgComponent={Success}
                                            onClickFunc={async () => {
                                                const ok = await step2ValidatorRef.current?.();
                                                if (!ok) return;

                                                // запускаем реальный submit Formik
                                                document
                                                    .querySelector('form')
                                                    ?.dispatchEvent(new Event('submit', {
                                                        cancelable: true,
                                                        bubbles: true
                                                    }));
                                            }}
                                            className={style.successBtn}
                                        >
                                            Оформить заявку
                                        </Button>
                                    </div>
                                </div>
                            </Form>
                        </>
                    )
                }}
            </Formik>
        </div>
    )
}


